$(".aside-filter-checkbox-group__item .checkbox").on("change", function () {
  $(this).find('span').toggleClass('checkbox-text_checked');
});